import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import SplitPayLearnMoreView from './CheckoutSplitPayLearnMoreView';
import { selectFinanceOffersByType, SplitPayOffer } from 'state/financeOffers';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import { mergeApplication } from 'state/creditApplication';

interface MatchParams {
  offerId: string;
}

const CheckoutSplitPayLearnMore: React.FC<
  RouteComponentProps<MatchParams>
> = props => {
  const dispatch = useDispatch();
  const { push } = useNavigationHelpers();

  const { splitPayOffers } = useSelector(selectFinanceOffersByType);

  const splitPayOffer = useMemo(
    () =>
      (splitPayOffers || []).find(
        splitPayOffer => (splitPayOffer.id = props.match.params.offerId),
      ) as SplitPayOffer,
    [splitPayOffers, props.match.params.offerId],
  );

  const nextPath = useCallback(() => {
    dispatch(mergeApplication({ selectedOfferId: splitPayOffer.id }));
    push(`/unified/checkout/splitpay/place-order/${splitPayOffer.id}`);
  }, [dispatch, push, splitPayOffer.id]);

  return (
    <SplitPayLearnMoreView
      nextPath={nextPath}
      capacityValue={splitPayOffer.capacityValue / 100}
    />
  );
};

export default CheckoutSplitPayLearnMore;
